import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection
} from 'angularfire2/firestore';
import * as firebase from 'firebase/app';

import { INotification } from './../../interfaces/notifications';
import { Observable } from 'rxjs';

@Injectable()
export class NotificationsProvider {
  private notificationsCollection: AngularFirestoreCollection<INotification>;

  constructor(private db: AngularFirestore) {}

  createNotification(userId: string, notification: INotification) {
    const id = this.db.createId();
    notification.id = id;
    notification.status = 0;
    const notificationRef = this.db.collection(`notifications`).doc(userId).collection(`notifications`).doc(id);
    notificationRef.set(notification);
    return notificationRef.update({
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  readNotification(userId: string, notificationId: string, status: number) {
    const newStatus = { status: status };
    const notificationRef = this.db
      .collection(`notifications`)
      .doc(`${userId}`)
      .collection(`notifications`)
      .doc(`${notificationId}`);
    notificationRef.update(newStatus);
    return notificationRef.update({
      modifiedAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  getNotifications(userId: string): Observable<INotification[]> {
    this.notificationsCollection = this.db
      .collection('notifications')
      .doc(userId)
      .collection<INotification>(`notifications`, ref =>
        ref.orderBy('createdAt')
      );
    return this.notificationsCollection.valueChanges();
  }

  getUnreadNotifications(userId: string): Observable<INotification[]> {
    this.notificationsCollection = this.db
      .collection('notifications')
      .doc(userId)
      .collection<INotification>(`notifications`, ref =>
        ref.where('status', '==', 0).orderBy('createdAt')
      );
    return this.notificationsCollection.valueChanges();
  }
}



// WEBPACK FOOTER //
// ./src/providers/notifications/notifications.ts